import { render, staticRenderFns } from "./LKPublicationsFormdataReportModal.vue?vue&type=template&id=bea2c8f8&"
import script from "./LKPublicationsFormdataReportModal.vue?vue&type=script&lang=js&"
export * from "./LKPublicationsFormdataReportModal.vue?vue&type=script&lang=js&"
import style0 from "./LKPublicationsFormdataReportModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports